import { EventDetailLoading } from '@/components/live/event-page/event-detail-boundaries';

export default function LiveEventLoading(): React.ReactNode {
  return <EventDetailLoading />;
}
